{
  "close": "Κλείσιμο",
  "notifications": "{count, plural, one {# ειδοποίηση} other {# ειδοποιήσεις}}."
}
